mutation TravelAuthorizationUrgentUpdate($input: TravelAuthorizationUrgentUpdateInput!) {
  travelAuthorizationUrgentUpdate(input: $input) {
    clientMutationId
         _newUrgentLevel
  }
}
